import React from 'react';
import { useSelector } from 'react-redux';
import agreementsReducer from 'reducers/entities/agreements';
import {
  getAgreementMyParticipant,
  getParticipantParty,
} from 'agreement/selectors';
import isEmpty from 'lodash/isEmpty';

import { GuestConversionModal } from './guest-conversion-modal';

type GuestConversionProps = {
  agreementId: number,
  onClose?: () => void,
  isSecondStep?: boolean,
  isOpen?: boolean,
  modalKey: string,
};

export const GuestConversion: React.FC<GuestConversionProps> = ({
  agreementId,
  onClose,
  isSecondStep,
  isOpen,
  modalKey,
}) => {
  const agreement = useSelector(
    (state) => agreementsReducer.getAgreementSelector(state, { id: agreementId }),
  );
  const myParticipant = React.useMemo(() => getAgreementMyParticipant(agreement), [agreement]);
  const myParticipantCompany = React.useMemo(
    () => getParticipantParty(agreement, myParticipant?.agreementCompany.id),
    [agreement, myParticipant?.agreementCompany.id],
  );
  if (isEmpty(agreement) || isEmpty(myParticipant) || isEmpty(myParticipantCompany)) {
    return null;
  }
  return (
    <GuestConversionModal
      agreementId={agreementId}
      myParticipant={myParticipant}
      myParticipantCompany={myParticipantCompany}
      onClose={onClose}
      isSecondStep={isSecondStep}
      isOpen={isOpen}
      modalKey={modalKey}
    />
  );
};

export default GuestConversion;
